export default __webpack_public_path__ + "static/media/laboback2.38cd39ce.jpg";